<template>
  <base-material-card color="primary" icon="mdi-pencil" inline class="px-5 py-3" title="Informações Básicas">
    <v-form class="pt-5">
      <v-row align="center" no-gutters class="ml-0">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required" name="Nome do relatório">
            <v-text-field v-model="nomeRelatorioLocal" label="Nome do Relatório" outlined :error-messages="errors" class="ml-4" />
          </validation-provider>
        </v-col>
      </v-row>
      <v-row align="center" no-gutters class="ml-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required" name="Base de dados">
            <v-select
              v-model="baseDadosLocal"
              no-gutters
              outlined
              :items="bases"
              :loading="loading"
              item-value="nome_tabela"
              item-text="descricao"
              label="Base de Dados"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
      </v-row>
      <v-row v-if="selecionarTodos && baseDadosLocal" align="center" no-gutters class="ml-4">
        <v-col cols="12">
          <v-checkbox v-model="todosCheckboxLocal">
            <template v-slot:label>
              <span class="black--text" title="Modo relatório analítico, resultado linha a linha sem agrupamentos de dados">
                Selecionar todos os campos
              </span>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  import BasesDadosService from '@/services/BasesDadosService';

  export default {
    props: {
      baseDados: {
        type: String,
        required: true
      },
      nomeRelatorio: {
        type: String,
        required: true
      },
      todosCheckbox: {
        type: Boolean,
        default: false
      },
      selecionarTodos: {
        type: Boolean,
        default: true
      }
    },

    data: () => ({
      bases: [],
      loading: false
    }),

    computed: {
      baseDadosLocal: {
        get() {
          return this.baseDados;
        },
        set(newValue) {
          this.todosCheckboxLocal = false;
          this.$emit('update:baseDados', newValue);
        }
      },

      nomeRelatorioLocal: {
        get() {
          return this.nomeRelatorio;
        },
        set(newValue) {
          this.$emit('update:nomeRelatorio', newValue);
        }
      },

      todosCheckboxLocal: {
        get() {
          return this.todosCheckbox;
        },
        set(newValue) {
          this.$emit('update:todosCheckbox', newValue);
        }
      }
    },

    created() {
      this.getBasesDados();
    },

    methods: {
      getBasesDados() {
        this.loading = true;
        BasesDadosService.getBasesDadosLiberadas()
          .then((response) => (this.bases = response.data))
          .catch(() => {
            this.$toast.error('Erro ao recuperar bases de dados para relatorios.', '', { position: 'topRight' });
          })
          .finally((this.loading = false));
      }
    }
  };
</script>
